import {Component, Inject} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MD_DIALOG_DATA, MdDialog, MdDialogConfig, MdDialogRef} from '@angular/material';
import {AddItemDialogComponent} from '../../../utilities/components/add-item-dialog/add-item-dialog.component';
import {Field} from '../../../form-builder/interfaces/Field';
import {FieldSelectorDialogComponent} from '../../../form-builder/components/field-selector-dialog/field-selector-dialog.component';
import {EFieldType} from '../../../form-builder/enums/e-field-type.enum';
import {CalculationService} from '../../../form-builder/services/calculation/calculation.service';
import {CalculationField} from '../../../form-builder/interfaces/CalculationField';
import {FieldGroup} from '../../../form-builder/interfaces/FieldGroup';
import {ContractItemService} from '../../services/contract-item/contract-item-service.service';
import {FieldGroupService} from '../../../form-builder/services/field-group/field-group.service';
import {StringUtilities} from '../../../utilities/StringUtilities';
import {CalculationResult} from '../../../form-builder/services/calculation/calculation-result.interface';

@Component({
  selector: 'app-contract-field-add-dialog',
  templateUrl: './contract-field-add-dialog.component.html',
  styleUrls: ['./contract-field-add-dialog.component.scss']
})
export class ContractFieldAddDialogComponent {
    formula: string;
    condition: string;
    result: string;
    condResult: string;
    signature: string;

    calculationFormGroup = new FormGroup({});
    addItemForm: FormGroup;
    calculation: FieldData[] = [];
    lettersModel: string[] = [];
    values = [];

    lettersArray = ['A', 'B', 'V', 'W', 'X', 'Y', 'Z'];
    caretPos = 0;
    constructor(public dialogRef: MdDialogRef<AddItemDialogComponent>,
                @Inject(MD_DIALOG_DATA) public data, public dialog: MdDialog,
                private formBuilder: FormBuilder,
                private calculationService: CalculationService,
                private contractItemService: ContractItemService,
                private fieldGroupService: FieldGroupService) {
        this.createForm();
    }
    /**
     * Scaffold out the fieldForm
     */
    createForm() {
        // object we will use to create the form group
        const group: any = {};
        if (this.data.item == null) {
            group['name'] = new FormControl('', Validators.required);
            group['description'] = new FormControl('', Validators.required);
            group['formula'] = new FormControl('', Validators.required);
            group['condition'] = new FormControl('', Validators.required);

        } else {
            group['name'] = new FormControl(this.data.item['name'], Validators.required);
            group['description'] = new FormControl(this.data.item['description'], Validators.required);
            group['formula'] = new FormControl(this.data.item['formula'], Validators.required);
            group['condition'] = new FormControl(this.data.item['condition'], Validators.required);
            this.formula = this.data.item['formula'];
            this.condition = this.data.item['condition'];
            this.contractItemService.getFields(this.data.item['id']).then((response: CalculationField[]) => {
                this.populateCalculation({ elements: response,
                    calculation: this.data.item['formula']
                });
            });
        }
        this.addItemForm = this.formBuilder.group(group);


    }

    populateCalculation(input) {
        // For each element in the input we run a request to get the fieldgroup associated with it
        for (const element of input.elements) {
            this.fieldGroupService
                .getFieldGroup(element.field_group_id)
                .then((response: FieldGroup) => {
                    // When we grab the fields associate with the field group we run through them until we find the correct one
                    const fieldsList = response.fields;
                    for (const field of fieldsList) {
                        if (field.id === element.field_id) {
                            // When we have the correct one we parse its fields and add it to the array of fields, making note of its index
                            const field2 = {...field, type: this.getEnumValueNumber(field.type), id: field.id};
                            this.calculationFormGroup.addControl(StringUtilities.camelize(field2.name), new FormControl(null));
                            const rowIndex = this.calculation.push(
                                {field: field2, fieldGroup: element.field_group_id,
                                    type: this.getEnumValueNumber(element.type), letter: element.letter}
                            ) - 1;
                            // With that index we put the identifier (letter) in the model for the dropdown
                            this.lettersModel[rowIndex] = element.letter;
                        }
                    }
                });
        }
        this.formula = input.calculation;
    }
    /**
     * Closes the dialog and returns the form value
     */
    onSubmit() {
        this.addItemForm.addControl('calculationFields', new FormControl(this.calculation));
        this.dialogRef.close(this.addItemForm.value);
    }

    removeField(field) {
        const index = this.calculation.indexOf(field);
        this.calculation.splice(index, 1);
        this.values.splice(field.field.id, 1);
        this.lettersModel.splice(index, 1);
    }

    optionSelected(option: string, index: number ) {
        this.calculation[index].letter = option;
    }

    onValueChanged(value, field: Field) {
        this.values[field.id] = value;
    }


    /**
     * When a field in the list is edited we run this method
     * @param {FieldData} field This indicates the field that has been clicked on
     */
    onFieldClick(field: FieldData) {
        this.dialog
            .open(FieldSelectorDialogComponent, <MdDialogConfig> {data: {fieldGroup : field.fieldGroup, parent: this.data.fieldGroup}})
            .afterClosed().subscribe(result => {
            if (result !== 'cancel' && result !== null && result !== undefined) {
                // We replace the field on the array for the new field, keeping the same position to keep track of the letters
                const index: number = this.calculation.indexOf(field);
                const field2 = {...result['field'], type: this.getEnumValueNumber(result['field'].type)};
                this.calculation[index] =
                    ({field: field2, fieldGroup: result['reportTemplateColumns'],
                        type: this.getEnumValueNumber(result['field'].type), letter: field.letter});
            }
        });
    }

    /**
     * This method handles the adding of a new field for the calculation
     */
    addField() {
        this.dialog
            .open(FieldSelectorDialogComponent, <MdDialogConfig> {data: {parent: this.data.fieldGroup}})
            .afterClosed().subscribe(result => {
            if (result !== 'cancel' && result !== null && result !== undefined) {
                    // When a field is added we push it to the array of fields that will be added to this field
                    const field2 = {...result['field'], type: this.getEnumValueNumber(result['field'].type)};
                    this.calculationFormGroup.addControl(StringUtilities.camelize(field2.name), new FormControl(null));
                    this.calculation.push({field: field2, fieldGroup: result['fieldGroup'],
                        type: this.getEnumValueNumber(result['field'].type)});
                    console.log('CALCULATIONS LIST', this.calculation);
            }
        });
    }

    /**
     *  This operation gets the position of the cursor in the text field
     *  This will help when indicating the errors to the user
     * @param oField Indicates the field event that dispatched this method
     * @param calculation Indicates the calculation that is taking place
     */
    getCaretPos(oField, calculation: number) {
        if (oField.selectionStart || oField.selectionStart === '0') {
            this.caretPos = oField.selectionStart;
        }
        // Any modification of the calculation field will cause an attempt to calculate the output.
        this.runCalculation(calculation);
    }


    /**
     * Calculates the example value of the calculation
     */
    runCalculation(calculation: number) {
        // To calculate the output we first make sure that all fields have both a letter assigned and a number assigned.
        let calculate = true;
        this.calculation.forEach((item, index) => {
            if (item.letter == null) {
                calculate = false;
            }
            if (!(item.field.id in this.values)) {
                calculate = false;
            }
        });
        if (calculate) {
            let valueArray = [];
            let type: number;
            for (const element of this.calculation) {
                let addVariable = true;

                if (calculation === 0 ) {
                    if (this.formula.search(new RegExp(element.letter, 'gi')) === -1) {
                        addVariable = false;
                    }
                } else {
                    if (this.condition.search(new RegExp(element.letter, 'gi')) === -1) {
                        addVariable = false;
                    }

                }
                if (addVariable) {
                    type = this.getEnumValueNumber(element.field.type);
                    valueArray.push({
                      key: element.letter,
                      value: this.getFieldValue(type, this.values[element.field.id].field)
                    });
                }
            }
            if (valueArray.length === 0) {
                valueArray = [];
                type = EFieldType.INTEGER;
            }
            if (calculation === 0) {
                this.calculationService.runCalculate(this.formula, valueArray, type)
                  .then((result: CalculationResult) => this.result = result.result);
            } else {
                this.calculationService.runCalculate(this.condition, valueArray, type)
                  .then((result: CalculationResult) => this.condResult = result.result);
            }
        }
    }

    getEnumValueNumber(value) {
        if (typeof value === 'string') {
            if (value === 'YES NO') {
                return EFieldType['YES_NO'];
            }
            return EFieldType[value];
        } else {
            return value;
        }
    }

    getFieldValue(type: number, field) {
        switch (type) {
            case 1:
                return field.check_value;
            case 2:
                return field.string_value;
            case 3:
                return field.int_value;
            case 4:
                return field.decimal_value;
            case 5:
                return field.select_value;
            case 6:
                return field.timestamp_value;
            case 7:
                return field.date_value;
            case 8:
                return field.check_value;
        }
    }


}

interface FieldData {
    fieldGroup: number;
    letter?: string;
    type?: number;
    field: Field;
}





// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/contract/components/contract-field-add-dialog/contract-field-add-dialog.component.ts